import React, { ReactElement } from 'react';
import ReviewCompleteBadgeImg from './images/review_complete_badge.png';
import './courseWorkSubmissionCard.module.scss';
import { ISODate } from '../../../../commonv3/types/dates';
import moment from 'moment-timezone';

type Props = {
  metaAttributes?: object;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  submissionCreatedAt?: ISODate | null;
  badge?: ReactElement;
};
export const CourseWorkSubmissionCard = ({ children, metaAttributes, badge, onClick, submissionCreatedAt }: Props) => {
  return (
    <div styleName="card" className="course-work-submission-card" {...(metaAttributes || {})} onClick={onClick}>
      {children}
      {submissionCreatedAt && (
        <div styleName="submission-completed-at">
          提出完了日：{moment(submissionCreatedAt).format('YYYY/MM/DD HH:mm')}
        </div>
      )}
      {badge}
    </div>
  );
};

export const ReviewCompleteBadge = () => (
  <img src={ReviewCompleteBadgeImg} styleName="review-complete-badge" className="review-complete-badge" />
);
